export class EnumHelper {
    static getKeysFromEnum(e: any) {
        const result = Object.keys(e).filter(x => isNaN(Number(x)));
        return result;
    }
}
